import React from "react"

const LINK_RE = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/
const CODE_RE = /`([^`\n]+)`/
const STRONG_RE = /\*\*([^*\n]+)\*\*/

function getNextToken(text) {
  const patterns = [
    { type: "link", regex: LINK_RE },
    { type: "code", regex: CODE_RE },
    { type: "strong", regex: STRONG_RE },
  ]

  return patterns.reduce((best, pattern) => {
    const match = text.match(pattern.regex)
    if (!match) return best

    const candidate = {
      type: pattern.type,
      index: match.index,
      match,
    }

    if (!best || candidate.index < best.index) {
      return candidate
    }

    return best
  }, null)
}

function createTextSegment(text) {
  return { type: "text", text }
}

function isSafeFaqUrl(value) {
  return /^https?:\/\/\S+$/i.test(value)
}

function parseInlineSegments(text) {
  const source = typeof text === "string" ? text : ""
  const segments = []
  let rest = source

  while (rest.length) {
    const token = getNextToken(rest)

    if (!token) {
      segments.push(createTextSegment(rest))
      break
    }

    if (token.index > 0) {
      segments.push(createTextSegment(rest.slice(0, token.index)))
    }

    const [raw, first, second] = token.match

    if (token.type === "link" && isSafeFaqUrl(second)) {
      segments.push({
        type: "link",
        text: first,
        href: second,
      })
    } else if (token.type === "code") {
      segments.push({
        type: "code",
        text: first,
      })
    } else if (token.type === "strong") {
      segments.push({
        type: "strong",
        text: first,
      })
    } else {
      segments.push(createTextSegment(raw))
    }

    rest = rest.slice(token.index + raw.length)
  }

  return segments.length ? segments : [createTextSegment(source)]
}

export function parseFaqLine(text) {
  const source = typeof text === "string" ? text : ""
  const isNote = source.startsWith("> ")
  const content = isNote ? source.slice(2) : source

  return {
    isNote,
    segments: parseInlineSegments(content),
  }
}

export function renderFaqSegments(segments, keyPrefix, classes = {}) {
  return segments.map((segment, index) => {
    const key = `${keyPrefix}-${index}`

    if (segment.type === "link") {
      return React.createElement(
        "a",
        {
          key,
          href: segment.href,
          target: "_blank",
          rel: "noopener noreferrer",
        },
        segment.text
      )
    }

    if (segment.type === "code") {
      return React.createElement(
        "code",
        {
          key,
          className: classes.inlineCode,
        },
        segment.text
      )
    }

    if (segment.type === "strong") {
      return React.createElement("strong", { key }, segment.text)
    }

    return React.createElement(React.Fragment, { key }, segment.text)
  })
}
